<template>
  <div class="fukidashi-components" :class="{'is-left' : isLeft}">
    <div class="fukidashi">
      <div class="fukidashi-inner">
        <p class="title">
          {{title}}
        </p>
        <p class="message" v-html="message">
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Fukidashi',
  props: {
    title: String,
    message: String,
    isLeft: Boolean
  },
  // data() {
	// 	return {
  //     intersectionObserver: null,
	// 	}
	// },
  // methods: {
  //   startIntersectionObserver: function(targets) {
  //     this.intersectionObserver = new IntersectionObserver(changes => {
  //       changes.forEach(change => {
  //         if(change.isIntersecting) {
  //           change.target.classList.add('is-show');
  //         }
  //       });
  //     },{
  //       rootMargin: "-150px",
  //       // threshold: [0,0.2,0.4,0.6,0.8,1.0],
  //       threshold: [1.0],
  //     });
  //     targets.forEach(target => {
  //       this.intersectionObserver.observe(target);
  //     });
  //   },
  // },
  // mounted() {
  //   const targets = Array.from(document.querySelectorAll('.fukidashi-components'));
  //   this.startIntersectionObserver(targets);
  // },
  // destroyed () {
  //   this.intersectionObserver.disconnect(); // すべての target に対し，監視をやめる
  // }
}
</script>
<style scoped lang="scss">
.fukidashi-components {
  position: absolute;
  top: 35px;
  padding: 20px 30px;
  border-radius: 10px;
  background-color: #ffce48;
  z-index: 1;
  opacity: 0;
  transform: translateY(20px);
  transition: opacity 0.5s cubic-bezier(0.77, 0, 0.175, 1), transform 0.5s cubic-bezier(0.77, 0, 0.175, 1);
  @media print, screen and (max-width: 900px) {
    padding: 10px;
  }
  &.is-show {
    opacity: 1;
    transform: translateX(0px);
  }
  &:before {
    content: "";
    border-style: solid;
    position: absolute;
    width: 0;
    height: 0;
    margin: 0;
  }
  &:not(.is-left) {
    margin-left: 80px;
    border-radius: 0px 10px 10px 10px;
    @media print, screen and (min-width: 901px) {
      left: 50%;
    }
    &:before {
      top: 0;
      left: -25px;
      border-color: transparent #ffce48 transparent transparent;
      border-width: 0 35px 40px 0;
      @media print, screen and (max-width: 900px) {
        border-width: 0 15px 20px 0;
        left: -15px;
      }
    }
  }
  &.is-left {
    @media print, screen and (min-width: 901px) {
      right: 50%;
      margin-right: 80px;
      border-radius: 10px 0px 10px 10px;
    }
    @media print, screen and (max-width: 900px) {
      margin-left: 80px;
      border-radius: 0px 10px 10px 10px;
    }
    &:before {
      top: 0px;
      @media print, screen and (min-width: 901px) {
        right: -30px;
        border-color: transparent transparent transparent #ffce48;
        border-width: 0 0 35px 40px;
      }
      @media print, screen and (max-width: 900px) {
        left: -15px;
        border-color: transparent #ffce48 transparent transparent;
        border-width: 0 15px 20px 0;
      }
    }
  }
}
.fukidashi-components + .fukidashi-components {
  margin-top: 30px;
}
.fukidashi {
  display: inline-block;
  position: relative;
  z-index: 1;
}
.fukidashi-inner {
  z-index: 1;
  position: relative;
}
.title {
  color: #e51c57;
  font-size: 15px;
  line-height: 2em;
  margin-bottom: 0;
  margin-top: 0;
}
.message {
  font-size: 12px;
  line-height: 2em;
  margin-bottom: 0em;
  @media print, screen and (max-width: 900px) {
    margin-top: 0;
  }
}
</style>
